<header class="header">
  <div class="header__left">
    <button type="button" class="header__menu" (click)="handleMenuToggle()">
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>

  @if (currentTimeLabel) {
    <div class="header__clock">
      <span>Current Time</span>
      <strong>{{ currentTimeLabel }}</strong>
    </div>
  }

  <div class="header__actions">
    <label class="app-status-switch header__mode-switch">
      <input
        class="app-status-switch__input"
        type="checkbox"
        [checked]="showBsDateEnabled"
        aria-label="Toggle BS / AD date display"
        (change)="toggleShowBsDate($any($event.target).checked)"
      />
      <span class="app-status-switch__track" aria-hidden="true">
        <span class="app-status-switch__thumb"></span>
        <span class="app-status-switch__label app-status-switch__label--inactive">AD</span>
        <span class="app-status-switch__label app-status-switch__label--active">BS</span>
      </span>
    </label>
    <button
      type="button"
      class="header__action-button"
      [class.header__action-button--active]="darkModeEnabled"
      [attr.aria-pressed]="darkModeEnabled"
      aria-label="Toggle dark mode"
      (click)="toggleDarkMode()"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M21 12.8A8.5 8.5 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z"></path>
      </svg>
    </button>
    <button type="button" class="header__action-button" aria-label="Settings" (click)="handleSettings()">
      <span>⚙</span>
    </button>

    <div class="header__divider"></div>

    <div class="header__user">
      <button type="button" class="header__user-button" (click)="toggleProfileMenu()">
        @if (displayUser.profileImageUrl) {
          <img class="header__avatar header__avatar--image" [src]="displayUser.profileImageUrl" [alt]="displayUser.fullName + ' profile image'" />
        } @else {
          <span class="header__avatar">{{ displayUser.initials }}</span>
        }
        <span class="header__user-copy">
          <strong>{{ displayUser.fullName }}</strong>
          <small>{{ displayUser.roleLabel }}</small>
        </span>
        <span class="header__chevron">▾</span>
      </button>

      @if (showProfileMenu) {
        <div class="header__menu-popover">
          <div class="header__menu-header">
            <strong>{{ displayUser.fullName }}</strong>
            <span>{{ displayUser.department }}</span>
          </div>
          <button type="button" class="header__menu-item" (click)="handleMyProfile()">My Profile</button>
          <button type="button" class="header__menu-item" (click)="handleSettings()">Settings</button>
          <button type="button" class="header__menu-item header__menu-item--danger" (click)="handleLogout()">
            Logout
          </button>
        </div>
      }
    </div>
  </div>
</header>
